module.exports = "div.collapsed {\n  overflow: hidden; }\n"